import { render, staticRenderFns } from "./answerNotClear.vue?vue&type=template&id=de5a7358"
import script from "./answerNotClear.vue?vue&type=script&lang=js"
export * from "./answerNotClear.vue?vue&type=script&lang=js"
import style0 from "./answerNotClear.vue?vue&type=style&index=0&id=de5a7358&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports